import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, search, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { EntregaIncompletaModelEdit } from "./incompleta";

import { DestinoItem } from "./item";

interface Props {
    items: models.Destino[];
    value: models.ViajeZEAppIniciado;
    idViajeZE: number;
}

interface State {
    busqueda: string;
}

const CancelarButton = kea.defaultProps(kea.Button, { children: "Cancelar viaje", style: "danger", iconClass: fa("times") });
const FinalizarButton = kea.defaultProps(kea.Button, { children: "Finalizar viaje", style: "success", iconClass: fa("check") });

/**Listado de los destinos */
export class DestinosList extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);
        this.state = { busqueda: "" };
    }

    modalManager = kea.createModalManager();

    busqueda = (props: Props, state: State) => state.busqueda;
    items = (props: Props, state: State) => props.items;
    itemsFiltrados = createSelectorRx(this.items, this.busqueda, (items, busqueda) =>
        items.filter(x => search(busqueda, x.NombreCliente + " " + x.Direccion.Descripcion))
    );

    onVerEntregas = async (x: models.Destino) => {
        history.go("./" + x.IdDireccionCliente);
    }

    onIncompleta = async (x: models.Destino) => {
        const idViajeZE = this.props.idViajeZE;
        const validacion = await resources.ViajeZEApp.PuedeAgregarIncompleta(this.props.idViajeZE, x.IdDireccionCliente);
        if (validacion != true) {
            await kea.message("Tiene entregas realizadas", "Este destino tiene guías entregadas o rechazadas por lo que no se puede marcar como incompleta", "warning");
            return;
        }

        const inicial: models.EntregaIncompletaViajeZEAppModel = { IdViajeZE: idViajeZE, IdDireccionDestino: x.IdDireccionCliente, Motivo: "" };
        const result = await this.modalManager.showModal(EntregaIncompletaModelEdit, undefined, inicial);
        if (result.result) {
            const value = result.value;
            const old = this.props.value;
            await resources.ViajeZEApp.RegistrarEntregaIncompleta(value);
            await kea.message("Destino incompleto", "Se marcó la entrega como incompleta", "warning");
        }
    }

    onCancelarViaje = async () => {
        if (await kea.yesno("¿Cancelar el viaje?")) {
            await resources.ViajeZEApp.CancelarViajeZEApp(this.props.value.IdViajeZE);
            await kea.message("Viaje cancelado");
        }
    }

    onFinalizarViaje = async () => {
        if (await kea.yesno("¿Finalizar viaje?")) {
            await resources.ViajeZEApp.FinalizarViajeZEApp(this.props.value.IdViajeZE);
            await kea.message("Viaje finalizado")
        }
    }

    onRegresar = () => {
        history.go("../");
    }

    render() {
        const items = this.itemsFiltrados(this.props, this.state);
        return (
            <div>
                <kea.Title titulo="Destinos del viaje de ZE" onRegresar={this.onRegresar} >
                </kea.Title>
                <div className="row">
                    <div className="col-md-2">
                        <kea.Number value={this.props.value.FolioViaje} label="Folio del Viaje ZE" readonly={true} />
                    </div>
                </div>

                <div className="btn-group">
                    <CancelarButton onClick={this.onCancelarViaje} />
                    <FinalizarButton onClick={this.onFinalizarViaje} />
                </div>
                <kea.Text addon={<i className={fa("search")} />} placeholder="Búsqueda" value={this.state.busqueda} onChange={x => this.setState({ busqueda: x })} />
                {
                    items.map(x => <DestinoItem
                        key={x.IdDireccionCliente}
                        value={x}
                        onEntregaIncompleta={() => this.onIncompleta(x)}
                        onVerEntregas={() => this.onVerEntregas(x)}
                    />)
                }
                {this.modalManager.component}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeappZE/destinos/listmem.tsx